import i18next from 'i18next'
export const eur = (v) =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v || 0);

export const price = (v) => {
  const amount = Number(v);
  return Number.isFinite(amount) && amount > 0
    ? eur(amount)
    : i18next.t("priceUponRequest", "Price upon request");
};

export const eurCompact = (v) => {
  if (v == null) return "€0";
  if (v >= 1000000) return i18next.t('valm', '€{{val}}M', { val: (v / 1000000).toFixed(v % 1000000 === 0 ? 0 : 1) });
  if (v >= 1000) return `€${Math.round(v / 1000)}k`;
  return eur(v);
};

export const num = (v) => new Intl.NumberFormat("pt-PT").format(v || 0);

export const fdate = (v) => {
  if (!v) return "—";
  try {
    return new Intl.DateTimeFormat("pt-PT", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(v));
  } catch {
    return "—";
  }
};

export const fdatetime = (v) => {
  if (!v) return "—";
  try {
    return new Intl.DateTimeFormat("pt-PT", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    }).format(new Date(v));
  } catch {
    return "—";
  }
};
